class ShapeFillRandomArgs {
    // layers    - number, How many layers to have  
    // coverage - double; how much of the spaces to cover, base values
    // thickness - how thick to make the layers.  
    //
    // curveRange - array [2] - the range of curves for each layer. 
    // sizeFactors - the size variation within the curves
    //               [2, 4] would indicate the size difference is up to 100%, 
    //               but only in increments of 50%. 
    //               [10, 20] would be 100% range, but 10% increments
    // spacing  - add spacing in between layers
    //
    //
    // coverageRange - Range of coverage to have. Interacts with the
    //                 coverage/attenuate variables to add randomness
    //                 to coverage but not fully determine it.
    //
    // change - double; whether to shrink or grow the filled space.
    //
    // disjointProtection - boolean, if the curve or shape has not connected
    //                      ends, use this to avoid overflow shapes
    //
    // resolution  - double; if you need a custom interval when getting 
    //          shape coordinates, use this

    constructor(
        layers,
        coverage,
        thickness,
        curveRange
    ) {
        this.layers = layers
        this.coverage = coverage
        this.thickness = thickness
        this.curveRange = curveRange

        this.change = 0
        this.spacing = 0
        this.sizeFactors = [1, 1]
        this.coverageRange = [1, 1]
        this.connectPoints = false
        this.disjointProtection = false
        this.resolution = 0.01
    }

    setSizeFactors(factors) {
        this.sizeFactors = factors
        return this
    }

    setCoverageRange(range) {
        this.coverageRange = range
        return this
    }

    setChange(change) {
        this.change = change
        return this
    }

    setConnectPoints(connect) {
        this.connect = connect
        return this
    }

    setSpacing(spacing) {
        this.spacing = spacing
        return this
    }

    setDisjointProtection(protection) {
        this.disjointProtection = protection
        return this
    }

    setHiRes(resolution) {
        this.resolution = resolution
        return this
    }
}

export { ShapeFillRandomArgs }
